
import {defineComponent, PropType} from 'vue';
import {ModsType} from "@/types/IModsData";
import DataMixins from "@/mixins/DataMixins";

export default defineComponent({
	name: 'MainCardComponent',
    props: {
        data: {
            type: Object as PropType<ModsType>,
            required: true
        },
    },
    mixins: [DataMixins]
})
